/* 生成小程序二维码 */
import {
    post
} from '@/util/request'

export const createWXQRCode = (path, width = 280) => {
    let data = {
        path: path,
        width: width
    }
    return post('/api/app/user/weiXinQRCode', data, {});
}